import { render, staticRenderFns } from "./DispositivosLegais.vue?vue&type=template&id=2b7173b1&"
import script from "./DispositivosLegais.vue?vue&type=script&lang=js&"
export * from "./DispositivosLegais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports